import { mixins, styled, theme } from 'ui/theme';
import { Link } from 'ui/components/primitives';

export const Step = styled.li`
  ${mixins.baseFont};
  align-items: center;
  color: ${theme.colors.action.navigation.standard.static};
  display: flex;
  font-size: ${theme.fontSizes.md};
  position: relative;

  svg {
    color: ${theme.colors.build.mediumMedium};
  }

  &[data-home='true'] {
    svg {
      color: inherit;
    }
  }
`;

export const StepLink = styled(Link)`
  &[data-disabled='true'] {
    pointer-events: none;
    color: ${theme.colors.build.mediumLight1};
  }
`;
